import { render, staticRenderFns } from "./UnitAdd.vue?vue&type=template&id=18295a0a&scoped=true"
import script from "./UnitAdd.vue?vue&type=script&lang=js"
export * from "./UnitAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18295a0a",
  null
  
)

export default component.exports